import React, { useState, useEffect } from "react";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { Checkbox, TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  chip: {
    marginBottom: 5,
  },
  input: {
    marginBottom: 3,
  },
}));

export const languages = [
  "en",
  "fr",
  "de",
  "es",
  "it",
  "nl",
  "ar",
  "hi",
  "pt",
  "ru",
  "th",
];

function SearchLanguages(props) {
  const [languageInput, setLanguageInput] = useState("");
  const { t } = useTranslation();
  const classes = useStyles();
  const styles = props.style ? { ...props.style } : {};

  return (
    <>
      <div
        style={{
          width: "100%",
          minWidth: !props.mobile && 300,
          maxWidth: 400,
          ...styles,
        }}
      >
        <Autocomplete
          disabled={props.disabled}
          classes={{
            tag: classes.chip,
            input: classes.input,
          }}
          disablePortal={props.disablePortal}
          multiple
          disableCloseOnSelect
          handleHomeEndKeys
          fullWidth
          id="search-languages"
          limitTags={3}
          openOnFocus
          size="small"
          options={languages}
          value={props.value}
          onChange={(_e, val) => {
            props.onChange && props.onChange(val);
          }}
          getOptionLabel={(option) => t(`language_${option}`)}
          renderOption={(option, { selected }) => (
            <React.Fragment>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              <>{t(`language_${option}`)}</>
            </React.Fragment>
          )}
          inputValue={languageInput}
          onInputChange={(_e, val) => {
            setLanguageInput(val);
          }}
          renderInput={(params) => (
            <TextField {...params} variant="standard" label="Search Language" />
          )}
        />
      </div>
    </>
  );
}

export default SearchLanguages;
